<template>
  <pt-refund-integral-audit class="pt-refund-integral-audit__withData" @exportRefund="exportRefund" :exportLoading="exportLoading" ref="table" :pageSize="pageSize"></pt-refund-integral-audit>
</template>

<script>
import PtRefundIntegralAudit from './index'
// import { dataExport } from 'utils/formUtils'
export default {
  name: 'pt-refund-integral-audit__withData',
  components: {
    'pt-refund-integral-audit': PtRefundIntegralAudit
  },
  data () {
    return {
      exportLoading: false,
      pageSize: 30
    }
  },
  computed: {
    page () {
      return this.$refs.table.page
    }
  },
  methods: {
    exportRefund (val) {
      let data = {
        ...val,
        pageable: {
          page: this.page,
          size: this.pageSize
        }
      }
      this.exportLoading = true
      this.$store.dispatch('getRefundPointsExportExcel', data).then(res => {
        this.exportLoading = false
        // dataExport(res)
        this.$message.success('数据准备中，完成导出后我们会将数据保存在“导出历史”中，您稍后下载即可')
      }).catch(err => {
        this.exportLoading = false
        this.$message(err || '导出退款订单失败')
      })
    }
  }
}
</script>
